export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / k ** i).toFixed(dm)) + ' ' + sizes[i];
};

export const fileSizeInMegaBytes = bytes => {
  return bytes / (1024 * 1024);
};

export const checkFileSizeLimit = (file, maximumUploadLimit) => {
  const fileSize = file?.file?.size || file?.size;
  const fileSizeInMB = fileSizeInMegaBytes(fileSize);
  return fileSizeInMB <= maximumUploadLimit;
};

export const isVideoFile = file => {
  const fileType = file?.file?.type || file?.type;
  return fileType && fileType.startsWith('video/');
};

export const checkWhatsAppVideoSizeLimit = (file, maximumVideoUploadLimit) =>
  checkFileSizeLimit(file, maximumVideoUploadLimit);

const ACTIVE_STORAGE_PATH = '/rails/active_storage/';

export const attachmentDownloadUrl = url => {
  if (!url || !url.includes(ACTIVE_STORAGE_PATH)) {
    return url;
  }
  const parsed = new URL(url);
  parsed.searchParams.set('disposition', 'attachment');
  return parsed.toString();
};
